import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createTaskDateHeaderStyles } from "./createTaskDateHeaderStyles";

type TaskDateHeaderProps = {
  children: string;
};

export const TaskDateHeader = ({ children }: TaskDateHeaderProps) => {
  const classes = createTaskDateHeaderStyles(useTheme());

  return (
    <div className={classes.headingWrapper}>
      <Typography
        variant="contentSmall"
        Component="h3"
        className={classes.heading}
      >
        {children}
      </Typography>
    </div>
  );
};
